import { useWindowDimensions } from 'react-native';
import { BREAKPOINTS } from '@garnish/constants';

import { usePrimedCheckBreakpoint } from './useCheckBreakpoint';
import { usePrimedCheckMinWidth } from './useCheckMinWidth';
import { usePrimedMatchByBreakpointIndex } from './useMatchByBreakpointIndex';

export const useBreakpointHelpers = (
  breakpoints = BREAKPOINTS,
): UseBreakpointHelperType => {
  const { width } = useWindowDimensions();

  return usePrimedBreakpointHelpers(width, breakpoints);
};

export const usePrimedBreakpointHelpers = (
  currentWidth: number,
  breakpoints = BREAKPOINTS,
): UseBreakpointHelperType => {
  const checkMinWidth = usePrimedCheckMinWidth(currentWidth, breakpoints);
  const currentBreakpoint = usePrimedCheckBreakpoint(checkMinWidth);
  const matchByBreakpointIndex =
    usePrimedMatchByBreakpointIndex(currentBreakpoint);

  return {
    checkMinWidth,
    currentBreakpoint,
    matchByBreakpointIndex,
    ...currentBreakpoint,
  };
};

type UseBreakpointHelperType = {
  readonly checkMinWidth: ReturnType<typeof usePrimedCheckMinWidth>;
  readonly currentBreakpoint: ReturnType<typeof usePrimedCheckBreakpoint>;
  readonly matchByBreakpointIndex: ReturnType<
    typeof usePrimedMatchByBreakpointIndex
  >;
} & ReturnType<typeof usePrimedCheckBreakpoint>;
